export default __webpack_public_path__ + "static/media/pin03@2x.592ac842.png";